import { render, staticRenderFns } from "./EcommerceTotalProfit.vue?vue&type=template&id=c1c2422c&"
import script from "./EcommerceTotalProfit.vue?vue&type=script&lang=js&"
export * from "./EcommerceTotalProfit.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceTotalProfit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports